import React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";

import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import GetInTouch from "../components/GetInTouch";
import TextContent from "../components/TextContent";

// import { textPageTplData } from "../data/page-tpl-text.data";

const PageText = ({ data, pageContext: { id, slug } }) => {
  const pageData = data.wpPage?.template?.textRichContent;
  const seoPageData = getCurrentPageSeo(id);
  const pageTitle = data.wpPage?.title || seoPageData.title;
  const hideForms =
    slug === "privacy-policy" || pageTitle?.toLowerCase() === "privacy policy";

  return (
    <Layout pageTitle={seoPageData.title} hideNewsletter={hideForms}>
      {/* SEO Data */}
      <Seo post={seoPageData} />

      {/* Content Section */}
      <Section>
        <TextContent {...data.wpPage} />
      </Section>

      {!hideForms && (
        <Section className="-mobile-full">
          <GetInTouch pageTitle={seoPageData.title} />
        </Section>
      )}

      <PageFooterSections pageData={pageData} />
    </Layout>
  );
};

export const query = graphql`
  query PageText($id: String) {
    wpPage(id: { eq: $id }) {
      title
      content
      template {
        ... on WpTemplate_Text {
          textRichContent {
            pageHead {
              text
              title
            }
            flexibleContent {
              ... on WpTemplate_Text_Textrichcontent_FlexibleContent_Text {
                fieldGroupName
                text
                margin {
                  screenSize
                  side
                  value
                }
            }
              ... on WpTemplate_Text_Textrichcontent_FlexibleContent_Button {
                fieldGroupName
                text
                link {
                  target
                  title
                  url
                }
                margin {
                  screenSize
                  side
                  value
                }
            }
            }

            # SECTION: FAQ
            faqSection {
              header
              items {
                question
                answer
              }
          }
          }
      }
      }
  }
  }
`;

export default PageText;
